import { fromUnixTime, isBefore, startOfDay } from 'date-fns';
import { CityDetailsResult } from 'app/models/types/store/location';
import { ProductsId } from '@webc/meeseeks-ui-sdk';

export const isSearchInvalid = ({
  passengerCount = null,
  departureDate = null,
  wheelchairsCount = null,
  notFulfilledProductDependencies = null,
  departureCity,
  arrivalCity,
}: {
  passengerCount: null | number;
  departureDate?: null | number;
  wheelchairsCount?: null | number;
  departureCity?: CityDetailsResult;
  arrivalCity?: CityDetailsResult;
  notFulfilledProductDependencies?: null | ProductsId[];
}) => {
  if (
    (departureCity && !departureCity.uuid && !departureCity.legacyId) ||
    (arrivalCity && !arrivalCity.uuid && !arrivalCity.legacyId)
  ) {
    return true;
  }

  if (wheelchairsCount !== null && (passengerCount === null || wheelchairsCount > passengerCount)) {
    return true;
  }

  if (passengerCount !== null && passengerCount < 1) {
    return true;
  }

  if (notFulfilledProductDependencies !== null && notFulfilledProductDependencies.length > 0) {
    return true;
  }

  if (departureDate !== null) {
    return isBefore(startOfDay(fromUnixTime(departureDate)), startOfDay(new Date()));
  }

  return false;
};
